import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { isValidFixType, VulnerabilitiesFilterKeys } from '../../../../shared/organizationPackages';
import * as PackageInventoryStore from '../../../redux/packageInventory';
import FilterCardCheckboxes from '../../generic/Filter/FilterCardCheckboxes';
import type { AnyFilter } from '../../../../shared/organizationPackages';
import type { SelectOption } from '../../../types';

const FIX_TYPE_OPTIONS: SelectOption[] = [
  { value: 'has_fix', label: 'Has fix' },
  { value: 'no_fix', label: 'No fix' },
];

type Props = {
  setFilters: (filter: AnyFilter) => void;
};

/**
 * PackageInventoryFiltersVulnHasFix displays two checkboxes which can be used to
 * filter packages by those that have fixable / unfixable vulns.
 */
const PackageInventoryFiltersVulnHasFix: VoidFunctionComponent<Props> = ({ setFilters }) => {
  const fixTypes = useSelector(PackageInventoryStore.selectors.getFiltersVulnFixTypes);

  // map current fixTypes to SelectOption format
  const selectedCheckboxes = fixTypes.map((fixType: string) => ({
    label: FIX_TYPE_OPTIONS.find(option => option.value === fixType)?.label || fixType,
    value: fixType,
  }));

  // handle onChange from FilterCardCheckboxes
  const onChange = (newSelected: SelectOption[]) => {
    const selectedFixTypes = newSelected.map(({ value }) => value).filter(isValidFixType);
    setFilters({ [VulnerabilitiesFilterKeys.FixTypes]: selectedFixTypes });
  };

  return (
    <FilterCardCheckboxes
      label="Fixable"
      options={FIX_TYPE_OPTIONS}
      values={selectedCheckboxes}
      onChange={onChange}
      testId="package-inventory-filters-vuln--has-fix"
    />
  );
};

export default PackageInventoryFiltersVulnHasFix;
